import React from "react";
import { useIntl } from "react-intl";

import { PrimaryButton, PrimaryButtonOutlined } from "@components/Button";
import Dialog from "@components/Dialog";
import Div from "@components/Div";
import { H3 } from "@components/Heading";
import Icon from "@components/Icon";
import { Text } from "@components/Text";

import { useBankIDLoginReminderDialog } from "./BankIDLoginReminderDialog.hooks";

const BankIDLoginReminderDialog = () => {
  const { messages } = useIntl();
  const {
    handleCloseBankIdReminderDialog,
    handleRedirectToMyProfile,
    isBankIdReminderDialogVisible,
  } = useBankIDLoginReminderDialog();

  return (
    <Dialog
      visible={isBankIdReminderDialogVisible}
      draggable={false}
      width={1}
      maxWidth="500px"
      onHide={handleCloseBankIdReminderDialog}
      m={[3, 3, 3, "auto"]}
    >
      <Div
        display="flex"
        flexDirection="column"
        alignItems="center"
        gridGap="20px"
      >
        <Icon name="bankID" fontSize="var(--fs-icon-xl)" />

        <H3>{messages.title_bankid_login}</H3>

        <Text textAlign="center">{messages.message_bank_id_available}</Text>

        <Div
          width={1}
          display="flex"
          flexDirection={["column", "column", "row", "row"]}
          alignItems="center"
          justifyContent="center"
          gridGap={[3, 3, 4, 4]}
        >
          <PrimaryButtonOutlined
            width={[1, 1, "fit-content", "fit-content"]}
            minWidth="200px"
            height="40px"
            label={messages.label_maybe_later}
            onClick={handleCloseBankIdReminderDialog}
          />

          <PrimaryButton
            type="submit"
            width={[1, 1, "fit-content", "fit-content"]}
            minWidth="200px"
            height="40px"
            label={messages.label_activate}
            onClick={handleRedirectToMyProfile}
          />
        </Div>
      </Div>
    </Dialog>
  );
};

export default BankIDLoginReminderDialog;
